import { ServerEnv } from 'Configs/ServerEnv'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import storeAuth from 'GlobalStores/User/StoreAuth'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import { last } from 'lodash'

import { proxiedDelete, proxiedGet, proxiedPost, proxiedPut, buildQueryObject } from 'Services/apiClient'

const GetOrderHistory = (baId, token) => {
    const params = buildQueryObject({ baId, ushopCountryCode: StoreCountry.Country3() }, ServerEnv.ENV === 'DEV' ? { isQa: 1 } : null)

    const headers = {
        'Content-Type': 'application/json',
        'authorization-hydra': `Bearer ${token}`
    }

    return proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/etlV2/ordersHistory`, {
        params,
        config: { headers }
    })
}

const GetOrderHistoryDetail = (token, orderRef) => {
    let ref = last(orderRef.split('/'))

    const params = buildQueryObject({ orderRef: ref, ushopCountryCode: StoreCountry.Country3() }, ServerEnv.ENV === 'DEV' ? { isQa: 1 } : null)

    const headers = {
        'Content-Type': 'application/json',
        'authorization-hydra': `Bearer ${token}`
    }

    return proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/etlV2/orderDetail`, {
        params,
        config: { headers }
    })
}

const GetSubscriptions = token => {
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
    }

    return proxiedGet(`${ServerEnv.Hydra()}/customers/me/autoorders`, {
        config: { headers }
    })
}

const GetSubscriptionsV2 = (token, baId) => {
    const params = buildQueryObject(
        {
            ushopCountryCode: StoreCountry.Country3(),
            collapse: 'hydra',
            filterOrder: 'feelgreat',
            loginId: baId
        },
        ServerEnv.ENV === 'DEV' ? { isQa: 1 } : null
    )

    const headers = {
        'Content-Type': 'application/json',
        'authorization-hydra': `Bearer ${token}`
    }

    return proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/etlV2/subscription`, {
        params,
        config: { headers }
    })
}

const GetSubscriptionsItems = (token, href) => {
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
    }

    return proxiedGet(href, {
        config: { headers }
    })
}

const GetAddress = (shipmentOptions, shipToAddress) => {
    const data = {
        shipment_options: shipmentOptions,
        shipToAddress
    }

    const headers = {
        'Content-Type': 'application/json'
    }

    return proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/hot/format/${StoreCountry.Country3()}/shop/address-format`, data, {
        config: { headers }
    })
}

const Creditcardaliases = (token, userCountry) => {
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
    }

    return proxiedGet(`${ServerEnv.HydraV6()}/customers/me/creditcardaliases/${userCountry}`, {
        config: { headers }
    })
}

const GetPeriod = (countryCode2Alpha, joinPeriod) => {
    const data = {
        country: countryCode2Alpha,
        system: 'AO',
        joinPeriod: joinPeriod || ''
    }

    return proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/topup/period`, data, {
        config: {
            Headers: {
                'Content-Type': 'applicaton/json'
            }
        }
    })
}

const GetPaymentDetail = (paymentId, baId) => {
    const data = {
        payment_id: paymentId,
        type: baId ? 'shop' : 'enroll',
        ba_id: baId || ''
    }

    return proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/detail/hydra`, data, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const SendEmailV3 = (data, countryCode3Alpha) => {
    let originalUrl = `https://${ServerEnv.MemberCalls2()}.unicity.com/email-api/email-v3/public/${countryCode3Alpha}/feelGreat`

    switch (countryCode3Alpha) {
        case 'AUS_WILL_LVE':
            originalUrl = `https://${ServerEnv.MemberCalls2()}.unicity.com/email-api/email-fg-journey/public/${countryCode3Alpha}/feelGreat`
            break

        default:
            delete data['baStatus']
            delete data['action']
            delete data['purchaseType']

            originalUrl = `https://${ServerEnv.MemberCalls2()}.unicity.com/email-api/email-v3/public/${countryCode3Alpha}/feelGreat`
            break
    }

    return proxiedPost(originalUrl, data, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const SendEmailV4 = (data, countryCode3Alpha) => {
    let originalUrl = `https://${ServerEnv.MemberCalls2()}.unicity.com/email-api/email-v4/public/${countryCode3Alpha}/feelGreat`

    switch (countryCode3Alpha) {
        case 'AUS_WILL_LVE':
            originalUrl = `https://${ServerEnv.MemberCalls2()}.unicity.com/email-api/email-fg-journey/public/${countryCode3Alpha}/feelGreat`
            break

        default:
            delete data['baStatus']
            delete data['action']
            delete data['purchaseType']

            originalUrl = `https://${ServerEnv.MemberCalls2()}.unicity.com/email-api/email-v4/public/${countryCode3Alpha}/feelGreat`
            break
    }

    return proxiedPost(originalUrl, data, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const CancelSubscription = (data, token) => {
    return proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/proxy/autoship-v2/delete`, data, {
        config: {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    })
}

const SkipDelivery = (data, token) => {
    return proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/proxy/autoship/skip`, data, {
        config: {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    })
}

const GetCreditAndArBalance = (baId, token) => {
    const params = buildQueryObject({ baId, ushopCountryCode: StoreCountry.Country3() }, ServerEnv.ENV === 'DEV' ? { isQa: 1 } : null)

    const headers = {
        'Content-Type': 'application/json',
        'authorization-hydra': `Bearer ${token}`
    }

    return proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/etlV2/credit/availableBalance`, {
        params,
        config: { headers }
    })
}

const FormatAddress = data => {
    const headers = {
        'Content-Type': 'application/json'
    }

    return proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/hot/format/${StoreCountry.Country3()}/feelGreat/address-format`, data, {
        config: { headers }
    })
}

const EditSubscriptions = (data, token) => {
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
    }

    return proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/proxy/${StoreCountry.Country3()}/subscriptions/edit`, data, {
        config: { headers }
    })
}

const SendNowSubscriptions = (data, token) => {
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
    }

    return proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/proxy/autoship/order`, data, {
        config: { headers }
    })
}

const SendNowAutoOrder = (data, token) => {
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
    }

    return proxiedGet(data, {
        config: { headers }
    })
}

// USHOP-2821 — FE-driven Send Now 3DS flow (JP/feelgreat).
// Per BE handoff (SEND-NOW-3DS-FLOW.md), /proxy/* + the FE→Hydra create call use a plain
// lowercase `authorization` header (raw token, no `Bearer`). BE to confirm; if these 401,
// switch to `Authorization: Bearer ${token}` (as the legacy SendNowSubscriptions uses).
const SendNowPrepare = (data, token) => {
    const headers = {
        'Content-Type': 'application/json',
        accept: 'application/json, text/plain, */*',
        authorization: token
    }

    return proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/proxy/autoship/order/prepare`, data, {
        config: { headers }
    })
}

const SendNowComplete = (data, token) => {
    const headers = {
        'Content-Type': 'application/json',
        accept: 'application/json, text/plain, */*',
        authorization: token
    }

    return proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/proxy/autoship/order/complete`, data, {
        config: { headers }
    })
}

// Direct FE→Hydra create. `hydraCreateUrl` comes from the prepare response; HttpHelper.Proxy
// is passthrough for JP so this posts straight to Hydra. Returns the full axios response so the
// caller can read response headers/body for the create_order log object.
const SendNowCreateOnHydra = (hydraCreateUrl, hydraBody, token) => {
    const headers = {
        'content-type': 'application/json',
        authorization: token
    }

    return proxiedPost(hydraCreateUrl, hydraBody, {
        config: { headers }
    })
}

const CreatePaymentDataForHostedGateway = (data, is3ds = false) => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/proxy/insert/${StoreCountry.Country3()}`

    return proxiedPost(url, data, {
        params: is3ds ? { is3ds: 1 } : undefined,
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const GatewayPaymentDetail = gatewayRefId =>
    proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/detail/proxy`, {
        gateway_ref_id: gatewayRefId,
        is_referral_code: true
    })

const GetGeoIPAccessAndBAID = ({ type = 'feelGreat', countryCode3Digit = StoreCountry.Country3(), baID = StoreAuth.GetId() }) =>
    proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/geoLocation/checkAllow/`, {
        params: {
            platform: type,
            countryCode: countryCode3Digit,
            baId: baID
        }
    })

const GetGeoIPAccessNoLogin = ({ type = 'feelGreat', countryCode3Digit }) =>
    proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/geoLocation/checkAllow/`, {
        params: {
            platform: type,
            countryCode: countryCode3Digit
        }
    })

const GetCityList = (countryCode3Digit = StoreCountry.Country3()) => proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/unishop-fn-misc/city/country/${countryCode3Digit}`)

const GetTHAAddressJSON = () => proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/fn-misc/city/THA`)

const CheckAcceptLanguage = ({ acceptLanguage, baId }) =>
    proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/validate/check-accept-language`, {
        acceptLanguage,
        ...(baId && { baId }),
        countryCode: StoreCountry.Country3(),
        platform: 'feelGreat'
    })

const CreditCardCheck = data =>
    proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/validate/creditCard/checkValidate`, data, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })

const HydraWorldPayReqForm = (URL, creditcardNumber) =>
    proxiedPost(`${URL}/ddc`, JSON.stringify({ bin: creditcardNumber }), {
        config: {
            headers: {
                'Content-Type': 'application/json',
                'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
            }
        }
    })

const deleteCache = baId =>
    proxiedDelete(`https://${ServerEnv.MemberCalls2()}.unicity.com/etlV2/cache/clearAll`, {
        params: buildQueryObject({ baId }, ServerEnv.ENV === 'DEV' ? { isQa: 1 } : null)
    })

const GetSubscriptionConfig = (countryCode3Digit = StoreCountry.Country3()) => proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/settings/subscriptionSettings/${countryCode3Digit}`)

const GetAddressHistory = (countryCode3Digit = StoreCountry.Country3()) => {
    const token = StoreAuth?.GetToken()
    const baId = StoreAuth?.GetId()

    return proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/etlV2/addressHistory`, {
        params: buildQueryObject({ baId, ushopCountryCode: countryCode3Digit }, ServerEnv.ENV === 'DEV' ? { isQa: 1 } : null),
        config: {
            headers: {
                'authorization-hydra': `Bearer ${token}`
            }
        }
    })
}

const saveAddressHistory = (shipToName, shipToAddress, countryCode3Digit = StoreCountry.Country3()) => {
    const token = StoreAuth?.GetToken()
    const baId = StoreAuth?.GetId()

    return proxiedPost(
        `https://${ServerEnv.MemberCalls2()}.unicity.com/etlV2/addressHistory`,
        {
            shipToName: { ...shipToName },
            shipToAddress: { ...shipToAddress }
        },
        {
            params: buildQueryObject({ baId, ushopCountryCode: countryCode3Digit }, ServerEnv.ENV === 'DEV' ? { isQa: 1 } : null),
            config: {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization-hydra': `Bearer ${token}`
                }
            }
        }
    )
}

const ValidateTaxInvoice = postData =>
    proxiedPut(`https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/${StoreCountry.Country3()}/feelGreat/address`, postData, {
        params: { validateTaxInvoice: 1 }
    })

const setPdpaStatus = data => {
    const params = ServerEnv.ENV === 'DEV' && ServerEnv.FORCE_ENV === 'DEV' ? { isQa: 1 } : undefined
    const token = storeAuth.GetToken()
    const tokenHydra = token
        ? token.startsWith('Bearer ')
            ? token
            : `Bearer ${token}`
        : undefined

    if (!token) console.error('[PDPA] Missing Hydra token')

    return proxiedPost(`https://${ServerEnv.MemberCalls2()}.unicity.com/pdpa/dataCheckbox`, data, {
        params,
        config: {
            headers: {
                'Content-Type': 'application/json',
                'authorization-hydra': tokenHydra
            }
        }
    })
}

const getPdpaStatus = baId =>
    proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/pdpa/data`, {
        params: { baId },
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })

export const updatePDPA = (customerHref, value, token) =>
    proxiedPut(
        `${ServerEnv.Hydra()}/customers/${customerHref}/updateVisibilityForUpliners`,
        {},
        {
            params: { hideContactInformation: value },
            config: {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                    'X-Application': `asia.ushop.${StoreCountry.Country2().toLowerCase()}`
                }
            }
        }
    )

const getFeelGreatProductsV3 = (balStatus = null) => {
    const params = balStatus ? { baStatus: balStatus } : undefined
    if (ServerEnv.ENV === 'DEV') {
        params.isQa = 1
    }

    return proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/products-v2/feelGreat/v3/publish/${StoreCountry.Country3()}`, {
        params,
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const getReferralCodes = token =>
    proxiedGet(`${ServerEnv.Hydra()}/customers/me/referralcodes`, {
        config: {
            headers: {
                Authorization: `Bearer ${token}`,
                'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
            }
        }
    })

const getFooter = () => proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/footer/data/public/${StoreCountry.Country3()}`)

const GetTrackingOrder = (token, orderNumber) => {
    const headers = {
        'Content-Type': 'application/json',
        'authorization-hydra': `Bearer ${token}`
    }

    return proxiedGet(`https://${ServerEnv.MemberCalls2()}.unicity.com/transportation/virgin/tracking/${orderNumber}`, {
        config: { headers }
    })
}

export const FeelGreatAPI = {
    GetOrderHistory,
    GetOrderHistoryDetail,
    GetPeriod,
    GetPaymentDetail,
    Creditcardaliases,
    GetSubscriptions,
    GetAddress,
    SendEmailV3,
    CancelSubscription,
    SkipDelivery,
    GetCreditAndArBalance,
    FormatAddress,
    EditSubscriptions,
    SendNowSubscriptions,
    SendNowAutoOrder,
    SendNowPrepare,
    SendNowComplete,
    SendNowCreateOnHydra,
    CreatePaymentDataForHostedGateway,
    GatewayPaymentDetail,
    GetGeoIPAccessAndBAID,
    GetGeoIPAccessNoLogin,
    CheckAcceptLanguage,
    GetCityList,
    CreditCardCheck,
    GetSubscriptionsItems,
    HydraWorldPayReqForm,
    deleteCache,
    GetSubscriptionConfig,
    GetAddressHistory,
    saveAddressHistory,
    ValidateTaxInvoice,
    setPdpaStatus,
    getPdpaStatus,
    getFeelGreatProductsV3,
    getReferralCodes,
    getFooter,
    SendEmailV4,
    GetSubscriptionsV2,
    GetTHAAddressJSON,
    GetTrackingOrder
}
